export default __webpack_public_path__ + "static/media/regulatory--detour-right--g1.ad60dd21.png";